import { LicensesUI } from './ui';
import { useLicensesData } from 'domains/licenses/hooks';

export const Licenses = (): JSX.Element => {
  const { data: licenses = [], isLoading, isError } = useLicensesData();

  return <LicensesUI licenses={licenses} isError={isError} isLoading={isLoading} />;
};
